import { Mesh } from './Mesh';
import { Selectable } from '../Selectable';
import { IColorChangeable, ICloneable, IScaleRelativeToCenter } from '../../Interfaces';
import { ConnectionPoint } from '../ConnectionPoint';
import { Scaler } from '../Scaler';

declare let THREE: any;


export interface ArcRecord {
  currentPoint: ConnectionPoint;
  currentLine: undefined;
  prevLine: undefined;
}

export class Arc extends Selectable implements IColorChangeable, ICloneable {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));
  private splineCurve;
  private color;
  scaler: Scaler;
  _boundingBox: any;
  static readonly Name = 'PolyLine';
  points: any[];

  constructor(points: any[] = []) {
    super();
    this.scaler = new Scaler();
    this.splineCurve = new THREE.SplineCurve();
    this.add(new Mesh());
    this.color = new THREE.Color(0x000000);
    points.forEach(p => this.addPoint(p));
    this.add(this.scaler);
    this.name = Arc.Name;
    this.points = points;

    this._boundingBox = new THREE.Box3();
  }

  canAddPoint() {
    return this.splineCurve.points.length < 3;
  }

  addPoint(point) {
    const curvePoints = this.splineCurve.points;
    if (this.canAddPoint()) {
      this.points.push(point);
      let cPoint = new ConnectionPoint(undefined, undefined);
      cPoint.position.set(point.x, 0, point.y);
      this.add(cPoint);
      point.cPoint = cPoint.id;
      curvePoints.push(point);

      if (curvePoints.length >= 2) {
        const arc = this.getObjectByName(Mesh.Name);
        const points = this.splineCurve.getPoints(50);
        arc.geometry.setFromPoints(points)
          .applyMatrix(Arc.rotationTransform);

        this.scaler.update();
      }
    }
  }

  update() {
    this.splineCurve.points.forEach(p => {
      const cp = this.children.filter(ch => ch.id === p.cPoint)[0];
      p.set(cp.position.x, cp.position.z);
    });
    const arc = this.getObjectByName(Mesh.Name);
    const points = this.splineCurve.getPoints(50);
    arc.geometry.setFromPoints(points)
      .applyMatrix(Arc.rotationTransform);
    this.selection.update();
    this.scaler.update();
  }

  objectsList(): Array<ArcRecord> {
    const cpoints = this.children.filter(ch => ch instanceof ConnectionPoint) as Array<ConnectionPoint>;
    const result = [];
    cpoints.forEach(point => {
      result.push({
        currentPoint: point,
        prevLine: this.getObjectById(point.prevLineId),
        currentLine: this.getObjectById(point.currentLineId)
      });

    });
    return result;
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName(Mesh.Name)];
  }

  setColor(color): void {
    this.color.copy(color);
    this.getObjectByName(Mesh.Name).setColor(color);
  }

  duplicate(): Arc {
    const arc = new Arc(this.splineCurve.points);
    arc.setColor(this.color);
    return arc;
  }

  highlight() {
    super.highlight();
    this.scaler.update();
    this.scaler.visible = true;
  }

  unhighlight() {
    super.unhighlight();
    this.scaler.visible = false;
    this.children.filter(ch => ch instanceof ConnectionPoint).forEach(ch => {
      ch.visible = false;
    });
  }

  getInfo() {
    const records = this.points;
    const points = [];
    records.forEach(rec => {
      points.push({ x: rec.x, y: rec.y });
    });
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    return {
      type: "Arc",
      position: pos,
      points: points,
      color: this.color.getHex()
    }
  }

  rebuild(info) {
    let arc = new Arc(info.points);
    arc.position = info.position;
    let color = new THREE.Color(info.color);
    return arc;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Arc/index.ts